module.exports = __webpack_public_path__ + "static/media/opensans-bold.fbfe7c2e.woff2";